import { render, staticRenderFns } from "./AtendimentoFormularioView.vue?vue&type=template&id=73b8ee45&scoped=true"
import script from "./AtendimentoFormularioView.vue?vue&type=script&lang=js"
export * from "./AtendimentoFormularioView.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoFormularioView.vue?vue&type=style&index=0&id=73b8ee45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b8ee45",
  null
  
)

export default component.exports